import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { Colors } from '../../theme'

export const Notice = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'compact',
})(({ compact }) => ({
  color: Colors.TEXT_ON_DARK_SUBTLE,
  fontSize: compact ? '0.65rem' : '0.75rem',
  lineHeight: 1.5,
  textAlign: 'center',
  maxWidth: 340,
  margin: '0 auto',
}))

export const NoticeLink = styled('a')(() => ({
  color: 'inherit',
  textDecoration: 'underline',
  textUnderlineOffset: 2,
  '&:hover': {
    color: Colors.WHITE,
  },
}))
